import { render, staticRenderFns } from "./el-radio.vue?vue&type=template&id=70fa3f35"
import script from "./el-radio.vue?vue&type=script&lang=js"
export * from "./el-radio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports